module.exports = "/_next/static/images/main-visual-menu-ac80926333023584f70131d1912c7969.jpg";